import React from "react";
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table,
    Typography
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {
    render() {
        const { bankSlipData, bankSlipDetail, selectedSearchValues, effectiveDate, } = this.props;
        const cellStyle = {
            border: '1px solid black',
            padding: '3px',
            fontSize: '0.6rem',
        };
        const formattedDate = moment(bankSlipDetail.date).format('YYMMMM').replace(/[a-zA-Z]+/, month => month.toUpperCase());
        const bankName = bankSlipDetail.bank == 1 ? "Bank of Ceylon" : "Other Banks";
        const transactionType = effectiveDate === moment(new Date()).format('YYYY-MM-DD') ? '52' : '23';
        const totalAmount = bankSlipData.reduce((sum, row) => sum + parseFloat(row.transferAmount || 0), 0);

        return (
            <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
                <Typography variant="h4" align="center" gutterBottom>
                    Bank Customer Slip File - {bankName}
                </Typography>

                <Box mb={2}>
                    <Typography variant="h6" align="center">
                        {selectedSearchValues.groupName} - {selectedSearchValues.factoryName}
                    </Typography>
                    {selectedSearchValues.routeName !== "0" && selectedSearchValues.routeName && (
                        <Typography variant="h6" align="center">
                            Route: {selectedSearchValues.routeName}
                        </Typography>
                    )}
                    <Typography variant="h6" align="center">
                        Month: {moment(bankSlipDetail.date).format('MMMM YYYY')}
                    </Typography>
                    <Typography variant="h6" align="center">
                        Date: {moment(effectiveDate).format('DD/MM/YYYY')}
                    </Typography>
                </Box>

                <div>&nbsp;</div>
                <Box minWidth={1050} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                    <TableContainer>
                        <Table size="small" aria-label="bank slip file">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" style={{ ...cellStyle, fontWeight: 'bold' }}>Customer Bank Code</TableCell>
                                    <TableCell align="center" style={{ ...cellStyle, fontWeight: 'bold' }}>Customer Branch Code</TableCell>
                                    <TableCell align="center" style={{ ...cellStyle, fontWeight: 'bold' }}>Account Number</TableCell>
                                    <TableCell align="center" style={{ ...cellStyle, fontWeight: 'bold' }}>Account Name</TableCell>
                                    <TableCell align="center" style={{ ...cellStyle, fontWeight: 'bold' }}>Transaction Type</TableCell>
                                    <TableCell align="center" style={{ ...cellStyle, fontWeight: 'bold' }}>Currency</TableCell>
                                    <TableCell align="center" style={{ ...cellStyle, fontWeight: 'bold' }}>Factory Bank Code</TableCell>
                                    <TableCell align="center" style={{ ...cellStyle, fontWeight: 'bold' }}>Factory Branch Code</TableCell>
                                    <TableCell align="center" style={{ ...cellStyle, fontWeight: 'bold' }}>Factory Account</TableCell>
                                    <TableCell align="center" style={{ ...cellStyle, fontWeight: 'bold' }}>Factory Account Name</TableCell>
                                    <TableCell align="center" style={{ ...cellStyle, fontWeight: 'bold' }}>Transaction Discription</TableCell>
                                    <TableCell align="center" style={{ ...cellStyle, fontWeight: 'bold' }}>Effective Date</TableCell>
                                    <TableCell align="center" style={{ ...cellStyle, fontWeight: 'bold' }}>Amount (Rs.)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {bankSlipData.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell align="center" style={cellStyle}>{row.customerBankCode || 'N/A'}</TableCell>
                                        <TableCell align="center" style={cellStyle}>{row.customerBranchCode || 'N/A'}</TableCell>
                                        <TableCell align="center" style={cellStyle}>{row.customerAccountNumber || 'N/A'}</TableCell>
                                        <TableCell align="left" style={cellStyle}>{row.customerAccountName || 'N/A'}</TableCell>
                                        <TableCell align="center" style={cellStyle}>{transactionType}</TableCell>
                                        <TableCell align="center" style={cellStyle}>SLR</TableCell>
                                        <TableCell align="center" style={cellStyle}>{row.factoryBankCode || 'N/A'}</TableCell>
                                        <TableCell align="center" style={cellStyle}>{row.factoryBranchCode || 'N/A'}</TableCell>
                                        <TableCell align="center" style={cellStyle}>{row.factoryAccountNumber || 'N/A'}</TableCell>
                                        <TableCell align="left" style={cellStyle}>{row.factoryAccountName || 'N/A'}</TableCell>
                                        <TableCell align="left" style={cellStyle}>BALANCEPAYMENT {formattedDate}</TableCell>
                                        <TableCell align="center" style={cellStyle}>{moment(effectiveDate).format('YY-MM-DD')}</TableCell>
                                        <TableCell align="right" style={cellStyle}>{parseFloat(row.transferAmount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    </TableRow>
                                ))}
                                <TableRow>
                                    <TableCell align="left" colSpan={12} style={{ ...cellStyle, fontWeight: 'bold' }}>Total</TableCell>
                                    <TableCell align="right" style={{ ...cellStyle, fontWeight: 'bold' }}>{totalAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                <div>&nbsp;</div>
                <Typography variant="body1" align="center">
                    ***** End of List *****
                </Typography>
            </div>
        );
    }
}